import {
  BarChartOutlined,
  BulbOutlined,
  NotificationOutlined,
  ControlOutlined,
  FilterOutlined,
  HistoryOutlined,
  PercentageOutlined,
  PictureOutlined,
  ProjectOutlined,
  RocketOutlined,
  SettingOutlined,
  ShoppingOutlined,
  SyncOutlined,
  TagsOutlined,
  TeamOutlined,
} from "@ant-design/icons"
import { ReactNode } from "react"

const ICON_REGISTRY: Record<string, ReactNode> = {
  rocket: <RocketOutlined />,
  shopping: <ShoppingOutlined />,
  tags: <TagsOutlined />,
  picture: <PictureOutlined />,
  bulb: <BulbOutlined />,
  project: <ProjectOutlined />,
  history: <HistoryOutlined />,
  filter: <FilterOutlined />,
  percentage: <PercentageOutlined />,
  control: <ControlOutlined />,
  sync: <SyncOutlined />,
  team: <TeamOutlined />,
  bar: <BarChartOutlined />,
  settings: <SettingOutlined />,
  notification: <NotificationOutlined />,
}

export const renderIcon = (name: string): ReactNode => ICON_REGISTRY[name] ?? null
